import Api from "@/services/Api";

export default {
  getSermons() {
    return Api().get('sermons');
  },
  getLatestSermons(limit) {
    return Api().get(`sermons/latest?limit=${limit}`);
  },
  getFeaturedSermons() {
    return Api().get("sermons/featured");
  },
  getRecentSermons(limit, page) {
    return Api().get(`sermons/recent?limit=${limit}&page=${page}`);
  },
  getSermonsByMonth(year) {
    return Api().get(`sermons/monthly/${year}`);
  },
  getSeriesList(limit, page) {
    return Api().get(`sermons/series?limit=${limit}&page=${page}`);
  },
  getSermonsBySeries(series) {
    return Api().get(`sermons/series/${series}`);
  },
  getSermonsByTopic() {
    return Api().get(`sermons/topics`);
  },
  getSermonsByScripture() {
    return Api().get(`sermons/scriptures`);
  },
  getBookList() {
    return Api().get('sermons/books');
  },
  getSermonsByBook(book) {
    return Api().get(`sermons/scriptures/${book}`);
  },
  getEvents() {
    return Api().get('events');
  },
  getLatestEvents(limit) {
    return Api().get(`events/latest?limit=${limit}`);
  },
  getCurrentEvent() {
    return Api().get(`events/current`);
  },
  getUpcomingEvents(limit, page) {
    return Api().get(`events/upcoming?limit=${limit}&page=${page}`);
  },
  getPastEvents(limit, page) {
    return Api().get(`events/past?limit=${limit}&page=${page}`);
  },
  getEvent(id) {
    return Api().get(`events/${id}`);
  },
  getDailyDevotional() {
    return Api().get("resources/daily-devotional");
  }
};



// WEBPACK FOOTER //
// ./src/services/AuthenticationService.js